<loadingindicator></loadingindicator>
<div class="container-fluid" [ngClass]="{ dashboard : loggedIn }">
    <div class="row">
        <div class="sidebar sidebar-hover col-3 bg-inverse pl-0 bg-dark" *ngIf="loggedIn">
            <nav-menu *ngIf="loggedIn && !isUnauthorized"></nav-menu>
        </div>
        <div class="col p-0 o-hidden">
            <div class="bg-white sticky-cover header">
                <div class="row pt-3 pb-3 pl-md-5 pr-md-5">
                    <div class="col">
                        <div class="row">
                            <div class="col col-auto pl-md-1">
                                <a [routerLink]="['/home']">
                                    <img src="images/deloitte-black.svg" class="hidden-xs hidden-sm" height="15"/>
                                </a>
                            </div>
                            <div class="col text-right">
                                <small>
                                    <i class="fa fa-globe mr-1"></i>
                                    <strong>{{businessFunctionName}}</strong>
                                    <span class="ml-2 mr-2 text-muted">|</span>
                                    <a href="/assets/HelpV1.1.pdf" target="_blank" class="text-primary"><strong>Help</strong></a>
                                    <span *ngIf="loggedIn" class="ml-2 mr-2 text-muted">|</span>
                                    <a *ngIf="loggedIn" class="pointer text-primary" (click)="showCookieSettings()"><strong>View cookies</strong></a>
                                    <span *ngIf="loggedIn" class="ml-2 mr-2 text-muted">|</span>
                                    <a *ngIf="loggedIn" class="text-primary" role="button" (click)="signOutClicked();"><strong>Sign out</strong></a>
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <router-outlet></router-outlet>
        </div>
    </div>
</div>